import { Schema } from "effect";

export const MessageInstagramCommentState = Schema.Literal(
  "normal",
  "deleted",
  "hidden",
  "edited",
);
export type MessageInstagramCommentState =
  typeof MessageInstagramCommentState.Type;

export const MessageInstagramCommentAttribute = Schema.Literal(
  "has_been_replied_to",
  "liked",
);
export type MessageInstagramCommentAttribute =
  typeof MessageInstagramCommentAttribute.Type;
